export const normalizeToken = (response: any): boolean => response.valid;
